import zigi from "./local/zigi.svg";
import x from "./local/x.svg";
import send from "./local/send.svg";
import arrowLeft from "./local/arrow-left.svg";
import telegram from "./local/telegram.svg";
import whatsapp from "./local/whatsapp.svg";
import facebookMessenger from "./local/facebook-messenger.svg";
import mtnApp from "./local/mtn-app.svg";
import mic from "./local/mic.svg";
import trash from "./local/trash.svg";
import pause from "./local/pause.svg";
import pbPause from "./local/pb-pause.svg";
import play from "./local/play.svg";
import greyCross from "./local/grey-x.svg";
import brandLogo from "./local/mtn-logo.svg";
import mtnWelcome from "./local/mtn-welcome.svg";
import blackX from "./local/black-x.svg";
import retry from "./local/retry.svg";
import globe from "./local/globe.svg";
import caret from "./local/caret.svg";
import pidgin from "./local/pidgin.svg";
import english from "./local/english.svg";
import igbo from "./local/igbo.png";
import hausa from "./local/hausa.png";
import yoruba from "./local/yoruba.png";
import rage from "./local/rage.svg";
import smiley from "./local/smiley.svg";
import star_struck from "./local/star-struck.svg";
import feedback_happy from "./local/feedback-happy.svg";
import feedback_sad from "./local/feedback-sad.svg";
import feedback_neutral from "./local/feedback-neutral.svg";
import yelloCareMainBanner from "./local/Y'ello_Care_Main_Banner_1.jpg";
import welcomeBanner from "./local/MTN4ME_Revised_B.jpg";




export const imageLinks = {
    logo: "https://mtnng-prod.superbo.ai/bm/web/chatbot/statics/Zigi_Emotions_Sunglass-optimize.gif",
    brandLogo,
    welcomeImage: mtnWelcome,
    yelloCareMainBanner,
    welcomeBanner,
    icon: {
        xIcon: x,
        greyCross,
        micIcon: mic,
        zigi,
        caret,
        sendIcon: send,
        pauseIcon: pause,
        pbPause,
        globeIcon: globe,
        playIcon: play,
        trashIcon: trash,
        error:retry,
        arrowLeft,
        blackX,
        telegram,
        whatsapp,
        facebookMessenger,
        mtnApp,
        pidgin,
        igbo,
        english,
        hausa,
        yoruba,
        rage,
        smiley,
        star_struck,
        feedback_neutral,
        feedback_sad,
        feedback_happy,

    }
}